// Default margin to cover clock skew and request latency
const DEFAULT_REFRESH_MARGIN_MS = 30 * 1000

// Returns the "exp" claim (ms since epoch) or 0 if token is missing / opaque / malformed
export const decodeJwtExpMs = (token) => {
  if (!token || typeof token !== 'string') return 0
  try {
    const payload = token.split('.')[1]
    if (!payload) return 0
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const json = JSON.parse(decodeURIComponent(escape(atob(normalized))))
    return typeof json.exp === 'number' ? json.exp * 1000 : 0
  } catch (e) {
    return 0
  }
}

// True when the token is missing or a decodable JWT that will expire within `marginMs`.
// Opaque / non-JWT tokens return false (nothing to compare against).
export const shouldRefreshAccessToken = (token, marginMs = DEFAULT_REFRESH_MARGIN_MS) => {
  if (!token) return true
  const expMs = decodeJwtExpMs(token)
  return expMs > 0 && expMs - Date.now() <= marginMs
}
